






























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import AdditionalPerson from './ItemAdditionalPerson.vue';
import AuthorizedPerson from './ItemAuthorizedPerson.vue';
import ItemList from '../common/ItemList.vue';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import * as FORM_INTERFACE from '../interfaces/accessTicket.interface';
import * as rules from '@/modules/shared/shared/domain/rules';

@Component({
    components: {
        AdditionalPerson,
        AuthorizedPerson,
        ItemList,
        FormNavigationButtons,
    },
})
export default class StepPeopleInvolved extends Vue {
    @Prop()
    oldInvolvedPeople!: FORM_INTERFACE.involvedPeopleInterface;

    isFormValid: boolean = false;
    modalCheck: boolean = true;
    directoryHeight: number = 200;
    maxPeople: number = 5;
    currentAdditionalPeople: number = 0;
    currentAuthorizedPeople: number = 1;

    authorizedPeople: FORM_INTERFACE.authorizedPeopleInterface[] = Array();

    authorizedPeopleIDs: number[] = Array();

    additionalPeople: FORM_INTERFACE.additionalPeopleInterface[] = Array();

    applicant: FORM_INTERFACE.applicantInterface = {} as FORM_INTERFACE.applicantInterface;

    rules: any = rules;

    $refs!: {
        form: any;
        list1: any;
        list2: any;
    };

    receiveAuthorizedPerson(data: any) {
        this.authorizedPeople.push(data);
    }

    receiveAdditionalPerson(data: any) {
        this.additionalPeople.push(data);
    }

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    previousStep() {
        this.$emit('previousStep');
    }

    sendData() {
        this.updateListData();
        let involvedPeople = {
            authorizedPeople: this.authorizedPeople,
            additionalPeople: this.additionalPeople,
            applicant: this.applicant,
        };
        return { involvedPeople };
    }

    updateListData() {
        this.additionalPeople = Array();
        this.authorizedPeople = Array();
        this.$refs.list1.requestData();
        this.$refs.list2.requestData();
    }

    get maxAuthorizedPeople() {
        return this.maxPeople - this.currentAdditionalPeople;
    }

    get maxAdditionalPeople() {
        return this.maxPeople - this.currentAuthorizedPeople;
    }

    calculateMaxAdditionalPeople(currentAuthorizedPeople: number) {
        this.currentAuthorizedPeople = currentAuthorizedPeople;
    }

    calculateMaxAuthorizedPeople(currentAdditionalPeople: number) {
        this.currentAdditionalPeople = currentAdditionalPeople;
    }

    @Watch('oldInvolvedPeople')
    assignOldValues(
        value: FORM_INTERFACE.involvedPeopleInterface,
        oldValue: FORM_INTERFACE.involvedPeopleInterface,
    ) {
        if (oldValue.authorizedPeople == undefined && oldValue.additionalPeople == undefined) {
            this.$refs.list1.setOldItems(this.oldInvolvedPeople.authorizedPeople);
            this.$refs.list2.setOldItems(this.oldInvolvedPeople.additionalPeople);
        }
    }

    authorizedPersonSelected(values: { newId: number; oldId: number | undefined }) {
        if (values.oldId === undefined) {
            this.authorizedPeopleIDs.push(values.newId);
        } else {
            this.authorizedPeopleIDs[this.authorizedPeopleIDs.indexOf(values.oldId)] = values.newId;
        }
        this.$refs.list1.setSelectedValues(this.authorizedPeopleIDs);
    }

    authorizedPersonDeleted(index: number) {
        this.authorizedPeopleIDs.splice(index, 1);
        this.$refs.list1.setSelectedValues(this.authorizedPeopleIDs);
    }
}
